// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"print-compare-successor_wrapper__ybJHL","title":"print-compare-successor_title__mZ491"};